import { axios } from "../../../lib/axios";
import { API_ROUTES } from "../../../lib/constants";

export const list = (params: {
  page: number;
  limit: number;
  search?: string;
  startDate?: string;
  endDate?: string;
}): Promise<any> => {
  return axios.get(API_ROUTES.LOGISTICS_REQUESTS, { params });
};
